export default __webpack_public_path__ + "static/media/not_pass.38b9299c.png";